// Copyright (c) 2016 Deere & Company

import PartRequestsSearchAside from './part-requests-search-aside';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    facets: state.partReturns.search.facets,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    }
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PartRequestsSearchAside);



// WEBPACK FOOTER //
// ./src/part-requests/search/components/part-requests-search-aside/index.js